
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserRegistrationData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrationData"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"registrationTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"confirmEmailStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"registrationAccessLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ssoRegistrationFields"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"ssoId"},"arguments":[],"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  

    module.exports = doc
  
